import Typography from '@/common/components/base/typography/Typography';
import StarImage from '@/modules/Statistics/assets/icons/Star.svg?react';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { GetSurveySummaryQueryResponseType } from '../../queries/getSurveySummary/getSurveySummaryQuery.type';

export default function SatisfactionSurvey({
  data,
}: {
  data?: GetSurveySummaryQueryResponseType;
}) {
  const rows = [
    {
      id: data?.id,
      title: 'دقت ارزیابی',
      score: data?.average_quality_score ?? 0,
      showStar: true,
    },
    {
      id: data?.id,
      title: 'نحوه ارتباط',
      score: data?.average_behavior_score ?? 0,
      showStar: true,
    },
    {
      id: data?.id,
      title: 'سرعت رسیدگی',
      score: data?.average_speed_score ?? 0,
      showStar: true,
    },
  ];

  return (
    <Box>
      {rows.map((row) => (
        <Flex
          key={row.id}
          alignItems="center"
          justifyContent="space-between"
          py="10px"
          direction="row"
        >
          <Typography
            color="black"
            textStyle="b1"
            className={css({
              flex: 1,
              textAlign: 'right',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            })}
          >
            {row.title}
          </Typography>

          <Flex
            alignItems="center"
            gap="4px"
            justifyContent="flex-end"
            className={css({ width: '60px', flexShrink: 0 })}
          >
            <Typography color="black" fontWeight="bold" fontSize={16}>
              {row.score}
            </Typography>

            <StarImage className={css({ width: '16px', height: '16px' })} />
          </Flex>
        </Flex>
      ))}
    </Box>
  );
}
